"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VNQRCode = void 0;
var _react = _interopRequireDefault(require("react"));
var _qrcode = _interopRequireDefault(require("qrcode.react"));
var _reactLoadingSkeleton = _interopRequireDefault(require("react-loading-skeleton"));
var _styles = require("@material-ui/core/styles");
var _reactI18next = require("react-i18next");
var _clsx = _interopRequireDefault(require("clsx"));
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var useStyles = (0, _styles.makeStyles)(function (_theme) {
  return {
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    justifyStart: {
      justifyContent: 'start'
    },
    qrCodeContainer: {
      padding: '10px 10px 6px 10px',
      backgroundColor: '#ffffff'
    }
  };
});

/**
 * Create a QR code
 * @param {string} text - The QR code text
 * @param {number} size - The size of the QR code
 * @param {boolean} loading - Whether to show Skeleton for loading
 * @param {boolean} backgroundEnabled - Wether to show background for QRCode
 * @param {SVG/Image} backgroundImage - if background enabled this required field will need to be supplied with 
 * an svg or an image
 */
var VNQRCode = function VNQRCode(props) {
  var loading = props.loading,
    text = props.text,
    justifyStart = props.justifyStart,
    _props$size = props.size,
    size = _props$size === void 0 ? 215 : _props$size;
  var classes = useStyles();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var renderCode = function renderCode() {
    if (loading) {
      return /*#__PURE__*/_react.default.createElement(_reactLoadingSkeleton.default, {
        width: "215px",
        height: "215px"
      });
    }
    if (text) {
      return /*#__PURE__*/_react.default.createElement(_Box.default, {
        className: classes.qrCodeContainer,
        zIndex: 1
      }, /*#__PURE__*/_react.default.createElement(_qrcode.default, {
        value: text,
        size: size,
        alt: t('QR_CODE')
      }));
    }
  };
  var renderBackground = function renderBackground() {
    if (props.backgroundEnabled) {
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          position: 'absolute',
          zIndex: 0
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: props.backgroundImage,
        alt: "background-image-svg"
      }));
    }
    return;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.root, justifyStart ? classes.justifyStart : '')
  }, renderBackground(), renderCode());
};
exports.VNQRCode = VNQRCode;